<app-page-header [pageTitle]="title"></app-page-header>

<app-line-chart
  [data]="data"
  [availableWidth]="windowWidth"
  [outerMargins]="chartMargins"
></app-line-chart>

<div class="btn-container">
  <button (click)="remove()">Remove point</button> |
  <button (click)="add()">Add Point</button>
</div>

<app-line-table [dataSource]="data"></app-line-table>
